// extracted by mini-css-extract-plugin
module.exports = {"wrap":"PropertyCode-hashed__wrap__gBD0n","left":"PropertyCode-hashed__left__2sbr6","right":"PropertyCode-hashed__right__pBcpy"};